import React, {ReactNode} from "react";
import {LoadingOverlayProperties} from "./LoadingOverlayInterface";
import PortalPureComponent from "../../components/PortalPureComponent";

/**
 * A LoadingOverlay component is used block the screen while loading usage blocking contents
 */
export default class LoadingOverlay extends PortalPureComponent<LoadingOverlayProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<div className={"overlay loading"} style={this.props.visible ? {} : {display: "none"}}>
				<span className="icon icon-spinner spin"/>
			</div>
		);
	}
}